var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',_vm._b({},'v-row',_vm.$attrs,false),[_c('v-col',{staticClass:"text-right text--secondary",attrs:{"cols":"4"}},[_vm._v(_vm._s(_vm.title)+" ")]),_c('v-col',{attrs:{"align":"left"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }